import React from "react";

const Next = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="54" height="54" rx="27" fill="white" />
      <rect x="1" y="1" width="54" height="54" rx="27" stroke="#004D90" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 21.9395L34.5303 27.4698V28.5304L29 34.0608L27.9393 33.0001L32.1893 28.7501H21.25V27.2501H32.1893L27.9393 23.0001L29 21.9395Z"
        fill="#004D90"
      />
    </svg>
  );
};

export default Next;
